import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { TopicsState } from '../../store';

@Component({
  selector: 'customer-app-topic-action-bar',
  templateUrl: './topic-action-bar.component.html',
  styleUrls: ['./topic-action-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TopicActionBarComponent {
  private topicsState = inject(TopicsState);

  topicsFilter = this.topicsState.topicsFilter;

  readonly calendarModification = input(false);

  public updateVisibleTopics(type: string): void {
    this.topicsState.updateCategories(type);

    const allOff = this.topicsState.topicsFilter().categories.every(category => !category.active);

    if (allOff) {
      this.topicsState.resetCategories();
    }
  }

  public resetCategoryFilter(): void {
    this.topicsState.resetCategories();
  }
}
